var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typage"},[_c('div',{staticClass:"grid mt-1"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"has-text-centered"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('ThankYouMessage.p_1'))+" ")]),(_vm.fromSurvey)?_c('p',[_vm._v(" "+_vm._s(_vm.$t('ThankYouMessage.p_survey'))+" ")]):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }